<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-4">
          <!--Modal-->
          <b-modal
            v-if="resetPassword"
            v-model="resetPassword"
            class="aligned"
            title="Reset Password"
            hide-footer
            @ok="resetPassword = false"
          >
            <p>We have sent an email to:</p>
            <p><b>{{ username }}</b></p>
            <p>Please use the link in the email to reset the password.</p>
            <form @submit.prevent="done">
              <button
                id="ButtonSignIn-id"
                type="submit"
                class="btn btn-primary login center-block modalSubmit"
              >
                Done
              </button>
            </form>
          </b-modal>
          <!--Modal-->
        </div>
      </div>
    </div>
    <footer class="login-footer">
      <img
        src="static/img/labs_logo.svg"
        class="labs-logo login center-block"
        alt="labs-img"
      >
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as Routes from '../constants/routes'

export default {

  name: 'ResetPasswordConfirmation',
  data () {
    return {
      resetPassword: true
    }
  },
  computed: {
    ...mapGetters([
      'username'
    ])
  },
  methods: {
    close: function () {
      this.$router.push(Routes.LOGIN)
    },
    done (event) {
      this.resetPassword = false
      this.close()
      this.$router.push(Routes.LOGIN)
    }
  }
}
</script>
